// extracted by mini-css-extract-plugin
module.exports = {"goToReport":"GoToReport_goToReport__3EK3w","title":"GoToReport_title__2Sgz1","link":"GoToReport_link__1rPGU","icon":"GoToReport_icon__1D-FU"};